import { country } from "../constants/country.js";

// Enhanced map of country names and codes to ISO Alpha-2 country codes
export const countryCodeMap = {
  // Direct ISO code mappings (for when API returns country codes)
  "AF": "AF", "AL": "AL", "DZ": "DZ", "AD": "AD", "AO": "AO", "AG": "AG", "AR": "AR", "AM": "AM",
  "AU": "AU", "AT": "AT", "AZ": "AZ", "BS": "BS", "BH": "BH", "BD": "BD", "BB": "BB", "BY": "BY",
  "BE": "BE", "BZ": "BZ", "BJ": "BJ", "BT": "BT", "BO": "BO", "BA": "BA", "BW": "BW", "BR": "BR",
  "BN": "BN", "BG": "BG", "BF": "BF", "BI": "BI", "KH": "KH", "CM": "CM", "CA": "CA", "CV": "CV",
  "CF": "CF", "TD": "TD", "CL": "CL", "CN": "CN", "CO": "CO", "KM": "KM", "CG": "CG", "CD": "CD",
  "CR": "CR", "HR": "HR", "CU": "CU", "CY": "CY", "CZ": "CZ", "DK": "DK", "DJ": "DJ", "DM": "DM",
  "DO": "DO", "EC": "EC", "EG": "EG", "SV": "SV", "GQ": "GQ", "ER": "ER", "EE": "EE", "SZ": "SZ",
  "ET": "ET", "FJ": "FJ", "FI": "FI", "FR": "FR", "GA": "GA", "GM": "GM", "GE": "GE", "DE": "DE",
  "GH": "GH", "GR": "GR", "GD": "GD", "GT": "GT", "GN": "GN", "GW": "GW", "GY": "GY", "HT": "HT",
  "HN": "HN", "HU": "HU", "IS": "IS", "IN": "IN", "ID": "ID", "IR": "IR", "IQ": "IQ", "IE": "IE",
  "IL": "IL", "IT": "IT", "JM": "JM", "JP": "JP", "JO": "JO", "KZ": "KZ", "KE": "KE", "KI": "KI",
  "KP": "KP", "KR": "KR", "KW": "KW", "KG": "KG", "LA": "LA", "LV": "LV", "LB": "LB", "LS": "LS",
  "LR": "LR", "LY": "LY", "LI": "LI", "LT": "LT", "LU": "LU", "MG": "MG", "MW": "MW", "MY": "MY",
  "MV": "MV", "ML": "ML", "MT": "MT", "MH": "MH", "MR": "MR", "MU": "MU", "MX": "MX", "FM": "FM",
  "MD": "MD", "MC": "MC", "MN": "MN", "ME": "ME", "MA": "MA", "MZ": "MZ", "MM": "MM", "NA": "NA",
  "NR": "NR", "NP": "NP", "NL": "NL", "NZ": "NZ", "NI": "NI", "NE": "NE", "NG": "NG", "MK": "MK",
  "NO": "NO", "OM": "OM", "PK": "PK", "PW": "PW", "PA": "PA", "PG": "PG", "PY": "PY", "PE": "PE",
  "PH": "PH", "PL": "PL", "PT": "PT", "QA": "QA", "RO": "RO", "RU": "RU", "RW": "RW", "KN": "KN",
  "LC": "LC", "VC": "VC", "WS": "WS", "SM": "SM", "ST": "ST", "SA": "SA", "SN": "SN", "RS": "RS",
  "SC": "SC", "SL": "SL", "SG": "SG", "SK": "SK", "SI": "SI", "SB": "SB", "SO": "SO", "ZA": "ZA",
  "ES": "ES", "LK": "LK", "SD": "SD", "SR": "SR", "SE": "SE", "CH": "CH", "SY": "SY", "TW": "TW",
  "TJ": "TJ", "TZ": "TZ", "TH": "TH", "TG": "TG", "TO": "TO", "TT": "TT", "TN": "TN", "TR": "TR",
  "TM": "TM", "TV": "TV", "UG": "UG", "UA": "UA", "AE": "AE", "GB": "GB", "US": "US", "UY": "UY",
  "UZ": "UZ", "VU": "VU", "VA": "VA", "VE": "VE", "VN": "VN", "YE": "YE", "ZM": "ZM", "ZW": "ZW",

  // Country names (original mappings)
  Afghanistan: "AF",
  Albania: "AL",
  Algeria: "DZ",
  Andorra: "AD",
  Angola: "AO",
  AntiguaAndBarbuda: "AG",
  Argentina: "AR",
  Armenia: "AM",
  Australia: "AU",
  Austria: "AT",
  Azerbaijan: "AZ",
  Bahamas: "BS",
  Bahrain: "BH",
  Bangladesh: "BD",
  Barbados: "BB",
  Belarus: "BY",
  Belgium: "BE",
  Belize: "BZ",
  Benin: "BJ",
  Bhutan: "BT",
  Bolivia: "BO",
  BosniaAndHerzegovina: "BA",
  Botswana: "BW",
  Brazil: "BR",
  Brunei: "BN",
  Bulgaria: "BG",
  BurkinaFaso: "BF",
  Burundi: "BI",
  Cambodia: "KH",
  Cameroon: "CM",
  Canada: "CA",
  CapeVerde: "CV",
  CentralAfricanRepublic: "CF",
  Chad: "TD",
  Chile: "CL",
  China: "CN",
  Colombia: "CO",
  Comoros: "KM",
  Congo: "CG",
  "Congo, Democratic Republic of the": "CD",
  CostaRica: "CR",
  Croatia: "HR",
  Cuba: "CU",
  Cyprus: "CY",
  CzechRepublic: "CZ",
  Denmark: "DK",
  Djibouti: "DJ",
  Dominica: "DM",
  DominicanRepublic: "DO",
  Ecuador: "EC",
  Egypt: "EG",
  ElSalvador: "SV",
  EquatorialGuinea: "GQ",
  Eritrea: "ER",
  Estonia: "EE",
  Eswatini: "SZ",
  // Ethiopia: "ET",
  Fiji: "FJ",
  Finland: "FI",
  France: "FR",
  Gabon: "GA",
  Gambia: "GM",
  Georgia: "GE",
  Germany: "DE",
  Ghana: "GH",
  Greece: "GR",
  Grenada: "GD",
  Guatemala: "GT",
  Guinea: "GN",
  GuineaBissau: "GW",
  Guyana: "GY",
  Haiti: "HT",
  Honduras: "HN",
  Hungary: "HU",
  Iceland: "IS",
  India: "IN",
  Indonesia: "ID",
  Iran: "IR",
  Iraq: "IQ",
  Ireland: "IE",
  Israel: "IL",
  Italy: "IT",
  Jamaica: "JM",
  Japan: "JP",
  Jordan: "JO",
  Kazakhstan: "KZ",
  Kenya: "KE",
  Kiribati: "KI",
  KoreaNorth: "KP",
  KoreaSouth: "KR",
  Kuwait: "KW",
  Kyrgyzstan: "KG",
  Laos: "LA",
  Latvia: "LV",
  Lebanon: "LB",
  Lesotho: "LS",
  Liberia: "LR",
  Libya: "LY",
  Liechtenstein: "LI",
  Lithuania: "LT",
  Luxembourg: "LU",
  Madagascar: "MG",
  Malawi: "MW",
  Malaysia: "MY",
  Maldives: "MV",
  Mali: "ML",
  Malta: "MT",
  MarshallIslands: "MH",
  Mauritania: "MR",
  Mauritius: "MU",
  Mexico: "MX",
  Micronesia: "FM",
  Moldova: "MD",
  Monaco: "MC",
  Mongolia: "MN",
  Montenegro: "ME",
  Morocco: "MA",
  Mozambique: "MZ",
  Myanmar: "MM",
  Namibia: "NA",
  Nauru: "NR",
  Nepal: "NP",
  Netherlands: "NL",
  NewZealand: "NZ",
  Nicaragua: "NI",
  Niger: "NE",
  Nigeria: "NG",
  NorthMacedonia: "MK",
  Norway: "NO",
  Oman: "OM",
  Pakistan: "PK",
  Palau: "PW",
  Panama: "PA",
  PapuaNewGuinea: "PG",
  Paraguay: "PY",
  Peru: "PE",
  Philippines: "PH",
  Poland: "PL",
  Portugal: "PT",
  Qatar: "QA",
  Romania: "RO",
  Russia: "RU",
  Rwanda: "RW",
  SaintKittsAndNevis: "KN",
  SaintLucia: "LC",
  SaintVincentAndTheGrenadines: "VC",
  Samoa: "WS",
  SanMarino: "SM",
  SaoTomeAndPrincipe: "ST",
  SaudiArabia: "SA",
  Senegal: "SN",
  Serbia: "RS",
  Seychelles: "SC",
  SierraLeone: "SL",
  Singapore: "SG",
  Slovakia: "SK",
  Slovenia: "SI",
  SolomonIslands: "SB",
  Somalia: "SO",
  SouthAfrica: "ZA",
  Spain: "ES",
  SriLanka: "LK",
  Sudan: "SD",
  Suriname: "SR",
  Sweden: "SE",
  Switzerland: "CH",
  Syria: "SY",
  Taiwan: "TW",
  Tajikistan: "TJ",
  Tanzania: "TZ",
  Thailand: "TH",
  Togo: "TG",
  Tonga: "TO",
  TrinidadAndTobago: "TT",
  Tunisia: "TN",
  Turkey: "TR",
  Turkmenistan: "TM",
  Tuvalu: "TV",
  Uganda: "UG",
  Ukraine: "UA",
  UnitedArabEmirates: "AE",
  "United Kingdom": "GB",
  "United States": "US",
  Uruguay: "UY",
  Uzbekistan: "UZ",
  Vanuatu: "VU",
  VaticanCity: "VA",
  Venezuela: "VE",
  Vietnam: "VN",
  Yemen: "YE",
  Zambia: "ZM",
  Zimbabwe: "ZW",

  // Alternative names and variations
  "UnitedKingdom": "GB",
  "UK": "GB",
  "Britain": "GB",
  "Great Britain": "GB",
  "England": "GB",
  "Scotland": "GB",
  "Wales": "GB",
  "Northern Ireland": "GB",
  
  // Localized names
  "Sverige": "SE", // Sweden in Swedish
  "Deutschland": "DE", // Germany in German
  "España": "ES", // Spain in Spanish
  "Italia": "IT", // Italy in Italian
  "Polska": "PL", // Poland in Polish
  "Россия": "RU", // Russia in Russian
  "中国": "CN", // China in Chinese
  "日本": "JP", // Japan in Japanese
  
  // Common variations
  "USA": "US",
  "America": "US",
  "United States of America": "US",
  "South Korea": "KR",
  "North Korea": "KP",
  "Czech Republic": "CZ",
  "South Africa": "ZA",
  "New Zealand": "NZ",
  "Saudi Arabia": "SA",
  "United Arab Emirates": "AE",
  "UAE": "AE",
};

/**
 * Enhanced helper to get ISO Alpha-2 country code from various input formats.
 * @param {string} countryInput - Country name, code, or variation
 * @returns {string|null} - ISO code or null if not found
 */
export const getCountryCode = (countryInput) => {
  if (!countryInput) return null;
  
  // Convert to string and trim
  const input = countryInput.toString().trim();
  if (!input) return null;
  
  // Try exact match first
  let code = countryCodeMap[input];
  if (code) return code;
  
  // Try case-insensitive match
  const lowerInput = input.toLowerCase();
  const matchingKey = Object.keys(countryCodeMap).find(
    key => key.toLowerCase() === lowerInput
  );
  if (matchingKey) return countryCodeMap[matchingKey];
  
  // Try without spaces (existing logic)
  const noSpaces = input.replace(/\s+/g, "");
  code = countryCodeMap[noSpaces];
  if (code) return code;
  
  // Try case-insensitive without spaces
  const noSpacesLower = noSpaces.toLowerCase();
  const matchingKeyNoSpaces = Object.keys(countryCodeMap).find(
    key => key.toLowerCase().replace(/\s+/g, "") === noSpacesLower
  );
  if (matchingKeyNoSpaces) return countryCodeMap[matchingKeyNoSpaces];
  
  // Check against country list constants
  const matchedConstant = country.find(
    c => c.country.toLowerCase() === input.toLowerCase() || c.iso.toLowerCase() === input.toLowerCase()
  );
  if (matchedConstant?.iso) return matchedConstant.iso.toUpperCase();

  // If it's already a 2-letter code, return it (in case it's a valid ISO code not in our map)
  if (input.length === 2 && /^[A-Z]{2}$/i.test(input)) {
    return input.toUpperCase();
  }
  
  return null;
};

// Reverse mapping from ISO codes to readable country names
export const countryNameMap = {
  "AF": "Afghanistan", "AL": "Albania", "DZ": "Algeria", "AD": "Andorra", "AO": "Angola",
  "AG": "Antigua and Barbuda", "AR": "Argentina", "AM": "Armenia", "AU": "Australia", "AT": "Austria",
  "AZ": "Azerbaijan", "BS": "Bahamas", "BH": "Bahrain", "BD": "Bangladesh", "BB": "Barbados",
  "BY": "Belarus", "BE": "Belgium", "BZ": "Belize", "BJ": "Benin", "BT": "Bhutan",
  "BO": "Bolivia", "BA": "Bosnia and Herzegovina", "BW": "Botswana", "BR": "Brazil", "BN": "Brunei",
  "BG": "Bulgaria", "BF": "Burkina Faso", "BI": "Burundi", "KH": "Cambodia", "CM": "Cameroon",
  "CA": "Canada", "CV": "Cape Verde", "CF": "Central African Republic", "TD": "Chad", "CL": "Chile",
  "CN": "China", "CO": "Colombia", "KM": "Comoros", "CG": "Congo", "CD": "Congo (Democratic Republic)",
  "CR": "Costa Rica", "HR": "Croatia", "CU": "Cuba", "CY": "Cyprus", "CZ": "Czech Republic",
  "DK": "Denmark", "DJ": "Djibouti", "DM": "Dominica", "DO": "Dominican Republic", "EC": "Ecuador",
  "EG": "Egypt", "SV": "El Salvador", "GQ": "Equatorial Guinea", "ER": "Eritrea", "EE": "Estonia",
  // "SZ": "Eswatini", "ET": "Ethiopia", "FJ": "Fiji", "FI": "Finland", "FR": "France",
  "GA": "Gabon", "GM": "Gambia", "GE": "Georgia", "DE": "Germany", "GH": "Ghana",
  "GR": "Greece", "GD": "Grenada", "GT": "Guatemala", "GN": "Guinea", "GW": "Guinea-Bissau",
  "GY": "Guyana", "HT": "Haiti", "HN": "Honduras", "HU": "Hungary", "IS": "Iceland",
  "IN": "India", "ID": "Indonesia", "IR": "Iran", "IQ": "Iraq", "IE": "Ireland",
  "IL": "Israel", "IT": "Italy", "JM": "Jamaica", "JP": "Japan", "JO": "Jordan",
  "KZ": "Kazakhstan", "KE": "Kenya", "KI": "Kiribati", "KP": "North Korea", "KR": "South Korea",
  "KW": "Kuwait", "KG": "Kyrgyzstan", "LA": "Laos", "LV": "Latvia", "LB": "Lebanon",
  "LS": "Lesotho", "LR": "Liberia", "LY": "Libya", "LI": "Liechtenstein", "LT": "Lithuania",
  "LU": "Luxembourg", "MG": "Madagascar", "MW": "Malawi", "MY": "Malaysia", "MV": "Maldives",
  "ML": "Mali", "MT": "Malta", "MH": "Marshall Islands", "MR": "Mauritania", "MU": "Mauritius",
  "MX": "Mexico", "FM": "Micronesia", "MD": "Moldova", "MC": "Monaco", "MN": "Mongolia",
  "ME": "Montenegro", "MA": "Morocco", "MZ": "Mozambique", "MM": "Myanmar", "NA": "Namibia",
  "NR": "Nauru", "NP": "Nepal", "NL": "Netherlands", "NZ": "New Zealand", "NI": "Nicaragua",
  "NE": "Niger", "NG": "Nigeria", "MK": "North Macedonia", "NO": "Norway", "OM": "Oman",
  "PK": "Pakistan", "PW": "Palau", "PA": "Panama", "PG": "Papua New Guinea", "PY": "Paraguay",
  "PE": "Peru", "PH": "Philippines", "PL": "Poland", "PT": "Portugal", "QA": "Qatar",
  "RO": "Romania", "RU": "Russia", "RW": "Rwanda", "KN": "Saint Kitts and Nevis", "LC": "Saint Lucia",
  "VC": "Saint Vincent and the Grenadines", "WS": "Samoa", "SM": "San Marino", "ST": "Sao Tome and Principe",
  "SA": "Saudi Arabia", "SN": "Senegal", "RS": "Serbia", "SC": "Seychelles", "SL": "Sierra Leone",
  "SG": "Singapore", "SK": "Slovakia", "SI": "Slovenia", "SB": "Solomon Islands", "SO": "Somalia",
  "ZA": "South Africa", "ES": "Spain", "LK": "Sri Lanka", "SD": "Sudan", "SR": "Suriname",
  "SE": "Sweden", "CH": "Switzerland", "SY": "Syria", "TW": "Taiwan", "TJ": "Tajikistan",
  "TZ": "Tanzania", "TH": "Thailand", "TG": "Togo", "TO": "Tonga", "TT": "Trinidad and Tobago",
  "TN": "Tunisia", "TR": "Turkey", "TM": "Turkmenistan", "TV": "Tuvalu", "UG": "Uganda",
  "UA": "Ukraine", "AE": "United Arab Emirates", "GB": "United Kingdom", "US": "United States",
  "UY": "Uruguay", "UZ": "Uzbekistan", "VU": "Vanuatu", "VA": "Vatican City", "VE": "Venezuela",
  "VN": "Vietnam", "YE": "Yemen", "ZM": "Zambia", "ZW": "Zimbabwe"
};

/**
 * Get readable country name from ISO code
 * @param {string} countryCode - ISO Alpha-2 country code
 * @returns {string} - Readable country name
 */
export const getCountryName = (countryCode) => {
  if (!countryCode) return null;
  return countryNameMap[countryCode.toUpperCase()] || null;
};

/**
 * Get display name for country - converts codes to names, keeps names as-is
 * @param {string} countryInput - Country data from API (code or name)
 * @returns {string} - Display-friendly country name
 */
export const getDisplayCountryName = (countryInput) => {
  if (!countryInput) return "Unknown";
  
  const input = countryInput.toString().trim();
  
  // If it's a 2-letter code, convert to readable name
  if (input.length === 2 && /^[A-Z]{2}$/i.test(input)) {
    const countryName = getCountryName(input);
    return countryName || input; // Return the code if no name found
  }
  
  // If it's already a readable name, return as-is
  return input;
};

/**
 * Resolve country code with enhanced logic for the trading cup table
 * @param {string} countryInput - Country data from API
 * @returns {string|null} - Resolved ISO Alpha-2 code
 */
export const resolveCountryCode = (countryInput) => {
  return getCountryCode(countryInput);
};
